<div id="page-buscador" class="flex flex-col flex-1 min-h-0 bg-base-200">

  <!-- Hero -->
  <div class="relative overflow-hidden px-6 py-8 lg:py-10">
    <img src="/img/background.png" width="1200" height="700" alt=""
         class="absolute inset-0 h-full w-full scale-105 object-cover blur-xs" />
    <div class="absolute inset-0 bg-linear-to-r from-black/85 via-black/60 to-black/25"></div>

    <div class="relative mx-auto max-w-7xl">

      <!-- Logo -->
      <div class="mb-6">
        <img src="/img/logo.png" width="640" height="480" alt="Tramitex" class="h-14 w-auto" />
      </div>

      <div class="grid gap-6 lg:grid-cols-[1fr_1.15fr] lg:items-center">

        <!-- Texto + stats -->
        <div>
          <div class="mb-3 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1 text-xs font-medium text-white/80 backdrop-blur-sm">
            <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
            Buscador Público de Gestorías
          </div>

          <h2 class="text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl">
            Encuentra la Gestoría Ideal
          </h2>
          <p class="mt-2 max-w-sm text-sm leading-relaxed text-white/65">
            Localiza agencias de gestoría gubernamental cerca de ti o por tipo de trámite.
          </p>

          <!-- Stats -->
          <div class="mt-5 flex items-center gap-5">
            <div>
              <p class="text-xl font-bold text-white">500+</p>
              <p class="text-xs text-white/55">Gestorías</p>
            </div>
            <div class="h-6 w-px bg-white/20"></div>
            <div>
              <p class="text-xl font-bold text-white">32</p>
              <p class="text-xs text-white/55">Estados</p>
            </div>
            <div class="h-6 w-px bg-white/20"></div>
            <div>
              <p class="text-xl font-bold text-white">4.8★</p>
              <p class="text-xs text-white/55">Calificación</p>
            </div>
          </div>
        </div>

        <!-- Card formulario -->
        <div class="card bg-base-100 shadow-2xl">
          <div class="card-body gap-3 p-5">
            <h3 class="text-sm font-bold text-base-content">Buscar gestorías</h3>

            <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <div class="sm:col-span-2">
                <label class="text-xs font-semibold text-base-content/50 tracking-wider mb-1 block uppercase">
                  Tipo de Trámite
                </label>
                <select class="select w-full select-sm">
                  <option>— Seleccionar trámite —</option>
                  <option>Licencia de Construcción</option>
                  <option>Permiso Ambiental</option>
                  <option>Registro de Marca</option>
                  <option>Apertura de Negocio</option>
                  <option>Uso de Suelo</option>
                  <option>Constitución de Empresa</option>
                  <option>Trámites IMSS/SAT</option>
                </select>
              </div>
              <div>
                <label class="text-xs font-semibold text-base-content/50 tracking-wider mb-1 block uppercase">
                  Estado
                </label>
                <select class="select select-sm w-full">
                  <option>— Seleccionar estado —</option>
                  <option>Ciudad de México</option>
                  <option>Nuevo León</option>
                  <option>Jalisco</option>
                  <option>Puebla</option>
                  <option>Estado de México</option>
                  <option>Guanajuato</option>
                  <option>Baja California</option>
                </select>
              </div>
              <div>
                <label class="text-xs font-semibold text-base-content/50 tracking-wider mb-1 block uppercase">
                  Código Postal
                </label>
                <label class="input input-sm w-full">
                  <svg class="h-3.5 w-3.5 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  </svg>
                  <input type="text" placeholder="Ej: 03100" class="grow" />
                </label>
              </div>
            </div>

            <div class="flex flex-col gap-2 sm:flex-row">
              <button type="submit" class="btn btn-primary btn-sm flex-1">
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
                Buscar Gestorías
              </button>
              <button type="button" class="btn btn-ghost btn-sm border-base-300">
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                </svg>
                Mi ubicación
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Resultados -->
  <div class="flex flex-col flex-1 min-h-0 px-6 pt-5">
    <div class="mx-auto w-full max-w-7xl flex flex-col flex-1 min-h-0 gap-4">
      <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between shrink-0">
        <div>
          <h3 class="text-base font-bold text-base-content">Gestorías Encontradas</h3>
          <p class="text-xs text-base-content/50 mt-0.5"><span class="text-primary font-semibold">6 resultados</span> para tu búsqueda</p>
        </div>
        <select class="select select-sm w-full sm:w-auto">
          <option>Ordenar: Más cercanas</option>
          <option>Mejor calificadas</option>
          <option>Más trámites</option>
        </select>
      </div>

      <div class="flex-1 overflow-y-auto pb-6">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">

      <!-- Card 1 -->
      <div class="card bg-base-100 shadow-sm border border-base-200 hover:shadow-md transition-shadow">
        <div class="card-body gap-4 p-5">
          <div class="flex items-start gap-3">
            <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary">
              <span class="text-sm font-bold text-primary-content">GM</span>
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-bold text-base-content">GestorMX Consultores</h4>
              <p class="mt-0.5 flex items-center gap-1 text-xs text-base-content/50">
                <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                </svg>
                Benito Juárez, CDMX · 1.2 km
              </p>
            </div>
            <div class="badge badge-warning badge-outline gap-1 shrink-0">
              <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              4.9
            </div>
          </div>

          <div class="flex flex-wrap gap-1.5">
            <span class="badge badge-info badge-soft">Construcción</span>
            <span class="badge badge-success badge-soft">Ambiental</span>
            <span class="badge badge-warning badge-soft">Mercantil</span>
          </div>

          <div class="space-y-1.5 text-xs text-base-content/60">
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              +52 55 1234 5678
            </p>
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Lun-Vie 9:00-18:00
            </p>
          </div>

          <button type="button" class="btn btn-primary btn-sm w-full">Contactar</button>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="card bg-base-100 shadow-sm border border-base-200 hover:shadow-md transition-shadow">
        <div class="card-body gap-4 p-5">
          <div class="flex items-start gap-3">
            <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary">
              <span class="text-sm font-bold text-secondary-content">TL</span>
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-bold text-base-content">Trámites Legales NL</h4>
              <p class="mt-0.5 flex items-center gap-1 text-xs text-base-content/50">
                <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                </svg>
                Monterrey, NL · 3.5 km
              </p>
            </div>
            <div class="badge badge-warning badge-outline gap-1 shrink-0">
              <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              4.7
            </div>
          </div>

          <div class="flex flex-wrap gap-1.5">
            <span class="badge badge-info badge-soft">Fiscal</span>
            <span class="badge badge-warning badge-soft">Mercantil</span>
          </div>

          <div class="space-y-1.5 text-xs text-base-content/60">
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              +52 81 9876 5432
            </p>
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Lun-Vie 8:00-17:00
            </p>
          </div>

          <button type="button" class="btn btn-primary btn-sm w-full">Contactar</button>
        </div>
      </div>

      <!-- Card 3 -->
      <div class="card bg-base-100 shadow-sm border border-base-200 hover:shadow-md transition-shadow">
        <div class="card-body gap-4 p-5">
          <div class="flex items-start gap-3">
            <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent">
              <span class="text-sm font-bold text-accent-content">GA</span>
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-bold text-base-content">Gestoría Ambiental Jalisco</h4>
              <p class="mt-0.5 flex items-center gap-1 text-xs text-base-content/50">
                <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                </svg>
                Guadalajara, Jal. · 0.8 km
              </p>
            </div>
            <div class="badge badge-warning badge-outline gap-1 shrink-0">
              <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              4.8
            </div>
          </div>

          <div class="flex flex-wrap gap-1.5">
            <span class="badge badge-success badge-soft">Ambiental</span>
            <span class="badge badge-info badge-soft">Construcción</span>
            <span class="badge badge-info badge-soft">Uso de Suelo</span>
          </div>

          <div class="space-y-1.5 text-xs text-base-content/60">
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              +52 33 5555 0011
            </p>
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Lun-Sáb 9:00-19:00
            </p>
          </div>

              <button type="button" class="btn btn-primary btn-sm w-full">Contactar</button>
        </div>
      </div>

      <!-- Card 4 -->
      <div class="card bg-base-100 shadow-sm border border-base-200 hover:shadow-md transition-shadow">
        <div class="card-body gap-4 p-5">
          <div class="flex items-start gap-3">
            <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-neutral">
              <span class="text-sm font-bold text-neutral-content">CF</span>
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-bold text-base-content">Consultoría Fiscal CDMX</h4>
              <p class="mt-0.5 flex items-center gap-1 text-xs text-base-content/50">
                <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                </svg>
                Coyoacán, CDMX · 2.1 km
              </p>
            </div>
            <div class="badge badge-warning badge-outline gap-1 shrink-0">
              <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              4.6
            </div>
          </div>
          <div class="flex flex-wrap gap-1.5">
            <span class="badge badge-info badge-soft">Fiscal SAT</span>
            <span class="badge badge-info badge-soft">IMSS</span>
            <span class="badge badge-warning badge-soft">Mercantil</span>
          </div>
          <div class="space-y-1.5 text-xs text-base-content/60">
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              +52 55 4444 7890
            </p>
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Lun-Vie 9:00-18:00
            </p>
          </div>
          <button type="button" class="btn btn-primary btn-sm w-full">Contactar</button>
        </div>
      </div>

      <!-- Card 5 -->
      <div class="card bg-base-100 shadow-sm border border-base-200 hover:shadow-md transition-shadow">
        <div class="card-body gap-4 p-5">
          <div class="flex items-start gap-3">
            <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-primary">
              <span class="text-sm font-bold text-primary-content">PU</span>
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-bold text-base-content">Permisos Urbanos Puebla</h4>
              <p class="mt-0.5 flex items-center gap-1 text-xs text-base-content/50">
                <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                </svg>
                Puebla, Pue. · 4.7 km
              </p>
            </div>
            <div class="badge badge-warning badge-outline gap-1 shrink-0">
              <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              4.5
            </div>
          </div>
          <div class="flex flex-wrap gap-1.5">
            <span class="badge badge-info badge-soft">Construcción</span>
            <span class="badge badge-info badge-soft">Uso de Suelo</span>
          </div>
          <div class="space-y-1.5 text-xs text-base-content/60">
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              +52 22 3311 9900
            </p>
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Lun-Vie 8:30-17:30
            </p>
          </div>
          <button type="button" class="btn btn-primary btn-sm w-full">Contactar</button>
        </div>
      </div>

      <!-- Card 6 -->
      <div class="card bg-base-100 shadow-sm border border-base-200 hover:shadow-md transition-shadow">
        <div class="card-body gap-4 p-5">
          <div class="flex items-start gap-3">
            <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary">
              <span class="text-sm font-bold text-secondary-content">RM</span>
            </div>
            <div class="flex-1 min-w-0">
              <h4 class="text-sm font-bold text-base-content">Registro de Marcas GDL</h4>
              <p class="mt-0.5 flex items-center gap-1 text-xs text-base-content/50">
                <svg class="h-3 w-3 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                </svg>
                Zapopan, Jal. · 6.3 km
              </p>
            </div>
            <div class="badge badge-warning badge-outline gap-1 shrink-0">
              <svg class="h-3 w-3" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
              </svg>
              4.7
            </div>
          </div>
          <div class="flex flex-wrap gap-1.5">
            <span class="badge badge-warning badge-soft">Marcas</span>
            <span class="badge badge-warning badge-soft">Mercantil</span>
            <span class="badge badge-success badge-soft">Ambiental</span>
          </div>
          <div class="space-y-1.5 text-xs text-base-content/60">
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
              </svg>
              +52 33 8800 2200
            </p>
            <p class="flex items-center gap-2">
              <svg class="h-3.5 w-3.5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              Mar-Sáb 9:00-18:00
            </p>
          </div>
          <button type="button" class="btn btn-primary btn-sm w-full">Contactar</button>
        </div>
      </div>

        </div>
      </div>
    </div>
  </div>
</div>
